import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { TwoFactorAuthorization } from '@app/entities/interfaces/ptrab/two-factor-authorization.interface';
import { PortugueseWithholding, Withholding } from '@app/entities/models/ptrab/withholding/withholding.model';

export interface WithholdingRepository {
  getWithholdingList(): Observable<Withholding[]>;
  editWithholding(withholding: Withholding, twoFactorAuthorization: TwoFactorAuthorization): Observable<Withholding>;
  getPortugueseWithholdingList(isEmployee: boolean): Observable<PortugueseWithholding>;
  onError$: any;
}

export const WITHHOLDING_REPOSITORY = new InjectionToken<WithholdingRepository>('WITHHOLDING_REPOSITORY');
